<template lang="pug">
  .money-info
    template(v-if="show_cost")
      .order-cost
        b Стоимость: {{order.cost}} {{this.order.currency_name}}
        .text-default(v-if="has_date_discount")
          small {{date_discount_str}}

      .text-success(v-if="order.discount > 0")
        small {{personal_discount_str}}
      .text-muted(v-else)
        small Персональная скидка не указана.

    .text-danger(v-if="order.penalty > 0")
      small {{penalty_str}}
    hr
    p.summary Итого: {{summary_cost}} {{order.currency_name}}


</template>

<script>
export default {
name: "OrderPriceSummary",
  props:{
    order: {
      type: Object,
      default: {
        cost:               {type: Number, default: 0},
        penalty:            {type: Number, default: 0},
        discount:           {type: Number, default: 0},
        date_discount:      {type: Number, default: 0},
        date_discount_type: {type: Number, default: 0},
      },
    },
  },
  date(){
    return {

    }
  },
  computed:{
    has_date_discount(){
      return ( (this.order.date_discount > 0) && (this.order.date_discount_type !== 'no_discount')  );
    },
    personal_discount_str(){
      return `Персональная скидка - ${this.order.discount} ${this.order.currency_name}`
    },
    penalty_str(){
      return `Штраф - ${this.order.penalty} ${this.order.currency_name}`
    },
    date_discount_str(){
      if (this.order.date_discount_type === 'fixed_value') {
        return `С учетом общей скидки ${this.order.date_discount} ${this.order.currency_name} с человека `
      } else {
        return `С учетом общей скидки ${this.order.date_discount}% `
      }
    },
    show_cost(){ return this.order.status !== 'canceled'},
    summary_cost(){
      let summary = 0;
      if (this.show_cost) {
        summary = this.order.total_cost + this.order.penalty
      } else {
        summary += this.order.penalty
      }
      return summary;
    },
  }
}
</script>

<style scoped>
 p.summary{
   font-size: 24px;
 }
</style>